import React from 'react';
import { useSelector } from 'react-redux';
import { statusSelector } from '../store/inventory-near-you/selector';
import { IDLE_STATUS } from '../../../../constants';
import GlobalLoading from '../../global/components/loading/GlobalLoading';

const Loading = () => {
  const status = useSelector(statusSelector);
  const showLoading = status !== IDLE_STATUS;
  return (
    <GlobalLoading show={showLoading} />
  );
};

export default Loading;